export default __webpack_public_path__ + "Content/Images/content/financial-freedom.jpg";